module.exports = __webpack_public_path__ + "img/img_hmi_lcd_console.7119003b.jpg";